import AddManually from "./AddManually";

export default AddManually;
